import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import _Button from '@material-ui/core/Button';
import { createIcon, Util, runtime, childrenText } from '../common';
import { getThemeColor, UIComponent, track } from '../components/Base';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { FormHelperText, ListItemIcon, Divider } from '@material-ui/core';
import Badge from './Badge';
import { Auth } from '../auth';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { Sheet } from './Modal';
import AddIcon from '@material-ui/icons/Add';
import CachedIcon from '@material-ui/icons/Cached';
import MergeTypeIcon from '@material-ui/icons/MergeType';
import CheckIcon from '@material-ui/icons/Check';
import ArrowRightAltIcon from '@material-ui/icons/ArrowRightAlt';
import WebIcon from '@material-ui/icons/Web';
import LanguageIcon from '@material-ui/icons/Language';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import TimelineIcon from '@material-ui/icons/Timeline';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Tooltip from 'codeArt/components/Tooltip';

export default class Button extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    onHidden() {
        let { onHidden } = this.props;
        if (onHidden) onHidden();
    }

    componentDidMount() {
        let my = this;
        Auth.verify(this.props, {
            before: () => {
                my.setState({
                    disabled: true,
                    disabledTip: "正在效验权限"
                });
            }, success: () => {
                my.setState({
                    disabled: false,
                    disabledTip: ""
                });
            }, error: (p) => {
                p = p || {};
                if (p.dark) {
                    //由于灰度原因无法访问
                    my.setState({ hidden: true });
                    my.onHidden();
                    return;
                }

                my.setState({
                    disabled: true,
                    disabledTip: "无此权限"
                });
            }
        });
    }

    render() {
        if (this.state.hidden) return null;
        let { disabled, disabledTip } = this.state;
        return <DrawButton disabled={disabled} disabledTip={disabledTip} {...this.props} />
    }
}

Button.defaultProps = {
    className: '',
    size: "md",
    shadow: 1,
    tipPlacement: "top"
}


function DrawButton(props) {

    const getTempProps = () => {
        let p = { className: '', ...props };
        delete p.tip; delete p.tipPlacement; delete p.color; delete p.icon; delete p.size; delete p.className; delete p.iconClassName; delete p.responsive; delete p.outline; delete p.permission; delete p.permissionData; delete p.role; delete p.drawerable;
        delete p.dark; delete p.disabledTip;
        return p;
    }

    const tooltip = (content) => {
        let { tip, tipPlacement, disabled, disabledTip } = props;
        return Tooltip({
            description: disabled ? disabledTip : tip,
            placement: tipPlacement,
            content: disabled ? <div>{content}</div> : content
        });
    }


    const draw = () => {
        let { color, icon, size, children, className, shadow, outline, style, disabled } = props;
        let iconClassName = getIconClassName(size);
        let sizeClassName = getSizeClassName(size);

        let p = getTempProps();
        let hasText = children && children.length > 0;
        if (!shadow) className += " shadow-none";
        icon = createIcon(icon, `${hasText ? 'mr-1' : ''} ${iconClassName}`, { key: 0 });
        color = color ? getThemeColor(disabled ? "disabled" : color, 'bg') : "";

        if (outline) className += " c-button-outline";
        let textColor = color ? `${color.indexOf("white") > -1 ? "c-text-dark" : "text-white"}` : "";
        return (
            tooltip(
                <_Button variant="contained" className={`jr-btn jr-btn-${size} ${color} ${textColor} ${!color ? 'c-button-default' : ''} ${sizeClassName} ${className}`} {...p}>
                    {icon ? [icon, children] : children}
                </_Button>)
        )
    }


    return draw();
};

export class ModalButton extends React.Component {

    render() {
        return (
            <Button shadow={0} size={"md"} className="c-ml-2" {...this.props} />
        );
    }
}

export class TextButton extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { color, size, children, icon, className } = this.props;
        var p = { ...this.props };
        delete p.color; delete p.size; delete p.icon;
        let hasText = children && children.length > 0;
        className = className || '';
        icon = createIcon(icon, `zmdi-hc-fw ${hasText ? 'mr-1' : ''}`, { key: 0 });
        return (
            <_Button className={`jr-btn text-${color} jr-btn-${size} ${className}`} {...p}>
                {icon ? [icon, children] : children}
            </_Button>
        );
    }
}


TextButton.defaultProps = {
    color: 'primary',
    size: "md"
}


function getIconClassName(size) {
    switch (size) {
        case "lg": return '';
        case "md": return 'c-icon-s1 c-lh-1';
        case "sm": return 'c-icon-s0d5 c-lh-1';
    }
    return ""; //todo
}

function getSizeClassName(size) {
    switch (size) {
        case "lg": return '';
        case "md": return 'c-px-3 c-text-s0d5 c-lh-1 c-h-2d2rem';
        case "sm": return 'c-px-3 c-text-s0d5 c-lh-1 c-h-2d2rem';
    }
    return ""; //todo
}


export class OutlinedButton extends React.Component {

    constructor(props) {
        super(props);
    }

    getSize(size) {
        switch (size) {
            case "sm": return "small";
            case "md": return "medium";
            case "lg": return "large";
        }
    }

    render() {
        let { color, size, children, icon, leftIcon, rightIcon, iconClassName, className } = this.props;
        let p = { ...this.props };
        delete p.color; delete p.size; delete p.icon; delete p.className; delete p.rightIcon; delete p.leftIcon; delete p.iconClassName;
        delete p.disabledTip;
        let hasText = children && children.length > 0;

        iconClassName = `${getIconClassName(size)} ${iconClassName}`;
        let sizeClassName = getSizeClassName(size);

        leftIcon = icon || leftIcon;
        leftIcon = createIcon(leftIcon, `${hasText ? 'mr-1' : ''} ${iconClassName}`, { key: "leftIcon" });
        rightIcon = createIcon(rightIcon, `${hasText ? 'ml-1' : ''} ${iconClassName}`, { key: "rightIcon" });
        return (
            <_Button variant="outlined" color={color} size={this.getSize(size)} className={`c-button ${sizeClassName} ${className}`} {...p}>
                {[leftIcon, children, rightIcon]}
            </_Button>
        );
    }
}


OutlinedButton.defaultProps = {
    color: 'primary',
    size: "md",
    className: '',
    iconClassName: ''
}


export class StarButton extends React.Component {

    constructor(props) {
        super(props);
    }

    onClick() {
        let { starred, toggle } = this.props;
        if (!toggle) return;
        toggle(!starred);
    }

    render() {
        let { starred } = this.props;
        return (
            <IconButton className="icon-btn" onClick={(e) => { this.onClick(); e.stopPropagation(); }}>
                {starred ?
                    <i className="zmdi zmdi-star text-amber" /> :
                    <i className="zmdi zmdi-star-outline" />
                }
            </IconButton>
        );
    }
}


StarButton.defaultProps = {

}

export class Link extends UIComponent {

    constructor(props) {
        super(props);
        this.state = {
            show: true
        }
    }

    hide() {
        this.setState({ show: false });
    }

    show() {
        this.setState({ show: true });
    }

    onHidden() {
        let { onHidden } = this.props;
        if (onHidden) onHidden();
    }

    componentDidMount() {//auth改动
        let my = this;
        let { disabled, disabledTip } = this.props;
        if (disabled === true) {
            my.setState({
                disabled,
                disabledTip,
            });
            return;
        }

        Auth.verify(this.props, {
            before: () => {
                my.setState({
                    disabled: true,
                    disabledTip: "正在效验权限"
                });
            }, success: () => {
                my.setState({
                    disabled: false,
                    disabledTip: ""
                });
            }, error: (p) => {
                p = p || {};
                if (p.dark) {
                    //由于灰度原因无法访问
                    my.setState({ hidden: true });
                    my.onHidden();
                    return;
                }

                my.setState({
                    disabled: true,
                    disabledTip: "无此权限"
                });
            }
        });

    }

    tooltip(content) {
        let { tip, tipPlacement } = this.props;
        let { disabled, disabledTip } = this.state;//auth改动
        return Tooltip({
            description: disabled ? disabledTip : tip,
            placement: tipPlacement,
            content
        })
    }

    getText(children) {
        if (this.props["data-gta-title"]) return this.props["data-gta-title"];
        return childrenText(children);
    }

    render() {
        if (this.state.hidden) return null;

        let { disabled, disabledTip } = this.state;//auth改动

        let { color, leftIcon, leftIconClassName, leftIconStyle, rightIcon, rightIconStyle, rightIconClassName, className, textClassName, weight, size, permission, permissionData, role, onClick, reverse, children, dark, sizeClassName, href, inline } = this.props;
        /*      if (!auth({ permission, permissionData, role, dark })) return null;  //权限验证 */ //auth改动

        let ps = { ...this.props };
        delete ps.color; delete ps.size; delete ps.leftIcon; delete ps.rightIcon; delete ps.leftIconClassName; delete ps.sizeClassName;
        delete ps.rightIconClassName; delete ps.leftIconStyle; delete ps.rightIconStyle; delete ps.className; delete ps.weight;
        delete ps.textClassName; delete ps.permissionData; delete ps.permission; delete ps.role; delete ps.onClick; delete ps.disabled; delete ps.right; delete ps.href; delete ps.dark; delete ps.tip; delete ps.tipPlacement; delete ps.disabledTip;
        delete ps.inline;

        sizeClassName = sizeClassName || linkSizeClassName[size];

        if (disabled) {
            color = "m-text-muted";
        }
        color = getThemeColor(color);
        if (leftIcon) leftIcon = createIcon(leftIcon, `zmdi jr-fs-xxl ${children ? 'mr-1' : ''} ${color} ${sizeClassName.icon} ${leftIconClassName}`, { style: leftIconStyle });
        if (rightIcon) rightIcon = createIcon(rightIcon, `zmdi jr-fs-xxl ${children ? 'ml-1' : ''} ${color} ${sizeClassName.icon} ${rightIconClassName}`, { style: rightIconStyle });

        let showClassName = this.state.show ? (inline ? 'd-inline' : "d-flex") : "d-none";

        if (!href) {
            return (
                this.tooltip(
                    <div data-gta-container="m" data-gta-title={this.getText(children)} className={`c-link-w ${showClassName} flex-row justify-content-center align-items-center ${(onClick && !disabled) ? 'c-pointer' : ''} ${className}`} onClick={(e) => { if (onClick && !disabled) onClick(e); }}>
                        {leftIcon}
                        {children ? <p className={`${inline ? 'd-inline' : ''} font-weight-${weight} ml-auto text-truncate c-link c-lh-1 ${color}  ${sizeClassName.text} ${textClassName}`} {...ps}>{children}</p> : null}
                        {rightIcon}
                    </div>
                )
            );
        }

        return (
            this.tooltip(
                <div className={`c-link-w ${showClassName} flex-row justify-content-center align-items-center ${(onClick && !disabled) ? 'c-pointer' : ''} ${className}`}>
                    {<a href={href} target="_blank" className={`font-weight-${weight} ml-auto text-truncate c-link c-lh-1 ${color}  ${sizeClassName.text} ${textClassName}`} {...ps}>{leftIcon}{children}{rightIcon}</a>}
                </div>
            )
        );
    }
}

const linkSizeClassName = {
    'xs': {
        text: 'c-text-s1',
        icon: 'c-icon-s1',
    },
    'sm': {
        text: 'c-text-s1d5',
        icon: 'c-icon-s1d5',
    },
    'md': {
        text: 'c-text-s2',
        icon: 'c-icon-s2',
    }
}

Link.defaultProps = {
    weight: "normal",
    className: '',
    size: "sm",
    textClassName: '',
    leftIconClassName: '',
    rightIconClassName: '',
    tipPlacement: "top",
    inline: false
}

Link.getSizeClassName = (size) => {
    return linkSizeClassName[size];
}

export class HelpLink extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        let { onClick, children, className, size, href, textClassName, leftIconClassName, tip } = this.props;
        let ext = {};
        if (onClick) {
            ext.onClick = () => { onClick(); };
        }
        return (
            <Link data-gta-title={this.props["data-gta-title"] || this.props["title"]} tip={tip}
                className={className} size={size} href={href} textClassName={textClassName} leftIcon={HelpOutlineIcon} leftIconClassName={leftIconClassName} {...ext}>{children}</Link>
        );
    }
}

export function CellLink(props) {  //专为表格使用的link
    let { icon } = props;
    let p = { ...props };
    delete p.icon;
    return <Link leftIcon={icon} size={"xs"} {...p}></Link>;
}

export function FlashOnCellLink(props) {  //专为表格使用的link
    return <CellLink icon={FlashOnIcon} {...props}>{props.label || "强度"}</CellLink>
}

export function WebCellLink(props) {  //专为表格使用的link
    return <CellLink icon={WebIcon} {...props}>{props.label || "浏览"}</CellLink>
}

export function LanguageCellLink(props) {  //专为表格使用的link
    return <CellLink icon={LanguageIcon} {...props}>{props.label || "浏览"}</CellLink>
}

export function EditCellLink(props) {  //专为表格使用的link
    return <CellLink icon={EditOutlinedIcon} {...props}>{props.label || "编辑"}</CellLink>
}

export function DeleteCellLink(props) {  //专为表格使用的link
    return <CellLink color="danger" icon={DeleteOutlinedIcon} {...props}>删除</CellLink>
}

export function DetailCellLink(props) {
    return <CellLink icon={ArrowRightAltIcon} {...props}>{props.label || "详情"}</CellLink>
}

export function GoCellLink(props) {  //专为表格使用的link
    return <CellLink icon={ChevronRightIcon} {...props}></CellLink>
}

export function ChecklLink(props) {  //专为表格使用的link
    return <CellLink icon={CheckIcon} {...props}>{"选定"}</CellLink>
}

export function MergelLink(props) {  //专为表格使用的link
    return <CellLink icon={MergeTypeIcon} {...props}>合并</CellLink>
}

export function AddLink(props) {
    return <Link leftIcon={AddIcon} size={"sm"} {...props}>{props.label || props.children || "新增"}</Link>;
}

export function FlashOnLink(props) {  //专为表格使用的link
    return <Link leftIcon={FlashOnIcon} color="warning" size={"sm"} {...props}>{props.label || "强度"}</Link>
}

export function EditLink(props) {
    let ps = getProps(props, EditOutlinedIcon);
    return <Link leftIcon={EditOutlinedIcon} size={"sm"} {...ps}>{props.children || "编辑"}</Link>;
}

export function DeleteLink(props) {
    return <Link color="danger" leftIcon={DeleteOutlinedIcon} size={"sm"} {...props}>{props.children || "删除"}</Link>;
}

export function OKLink(props) {
    return <Link leftIcon={CheckCircleOutlineIcon} size={"sm"} {...props}></Link>;
}

export function ClearLink(props) {
    return <Link leftIcon={CachedIcon} size={"sm"} {...props}></Link>;
}


export function CloseLink(props) {
    return <Link leftIcon={HighlightOffIcon} size={"sm"} {...props}></Link>;
}

export function DetailLink(props) {
    return <Link rightIcon={ArrowRightAltIcon} {...props}></Link>
}

export function GoLink(props) {
    return <Link rightIcon={ChevronRightIcon} {...props}></Link>
}

export function AnalyzLink(props) {
    return <Link rightIcon={TimelineIcon} {...props}></Link>
}

export function SettingLink(props) {
    let ps = getProps(props, SettingsOutlinedIcon);
    return <Link leftIcon={SettingsOutlinedIcon} size={"sm"} {...ps}></Link>;
}

export function ResearchLink(props) {
    return <Link leftIcon={FindReplaceIcon} {...props}></Link>
}


const getProps = (props, icon) => {
    let ps = { ...props };
    if (ps.right) {
        ps.rightIcon = icon;
        ps.leftIcon = null;
    }

    if (ps.left) {
        ps.rightIcon = null;
        ps.leftIcon = icon;
    }

    delete ps.right;
    delete ps.left;

    return ps;
}

class More extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: undefined,
            menuState: false,
            current: null
        }
    }


    componentDidMount() {//auth改动
        let my = this;
        let { options } = this.props;

        //由于多个选项可能存在验证需要，所以这里使用管道验证
        Auth.pipeline(options, {
            before: () => {
                my.setState({
                    disabled: true,
                    disabledTip: "正在效验权限"
                });
            }, success: (options) => {
                my.setState({
                    disabled: false,
                    disabledTip: "",
                    options
                });
            }, error: () => {
                my.setState({
                    disabled: true,
                    disabledTip: "无此权限"
                });
            }
        });

    }

    getCurrent() {
        return this.state.current;
    }

    onSelect(e, option) {
        let result = true;
        if (option.onClick) result = option.onClick(e);
        if (result !== false) {  //没有显示指定返回false，那么更改选项
            this.setState({
                current: option
            });
        }
        this.handleClose();
    }

    onOptionSelect = event => {
        event.stopPropagation();
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };

    handleClose = () => {
        this.setState({ menuState: false });
    };


    _renderButton({ disabled }) {
        let disabledTip = this.state.disabledTip || this.props.disabledTip;
        disabled = disabled || this.state.disabled || this.props.disabled;
        let content = this.renderButton({ disabled });
        if (disabled && disabledTip) {
            return Tooltip({
                key: 0,
                description: disabledTip,
                placement: "top",
                content: <div>{content}</div>
            })
        }
        return content;
    }

    renderButton({ disabled }) {
        let { style, type, className, iconClassName } = this.props;
        return (
            <IconButton key={0} className={`icon-btn p-2 ${className}`} disabled={disabled} style={style} onClick={this.onOptionSelect}>
                <i className={`zmdi zmdi-more-${type} ${iconClassName}`} />
            </IconButton>
        );
    }

    _menuItem(option, index) {
        return (
            <MoreItem key={index} data={option} onClick={(e) => {
                if (option.href)
                    this.handleClose()
                else
                    this.onSelect(e, option);
            }} />
        );
    }

    renderMenuItem(option, index) {
        if (option.auth === false) return null;

        if (!option.help) {
            return this._menuItem(option, index);
        }
        return Tooltip({
            key: index,
            description: option.help,
            placement: "left",
            content: (
                <div key={index}>
                    {this._menuItem(option, index)}
                </div>)
        })
    }

    menuAnchor() {
        const { anchorEl } = this.state;
        return { anchorEl };
    }

    render() {
        let { style, type, width, className, iconClassName } = this.props;
        const { menuState, anchorEl } = this.state;
        //let options = this.state.options || this.props.options;
        let options = this.props.options || this.state.options;
        let items = options.map((option, index) => this.renderMenuItem(option, index)).filter((t) => t);
        return (
            [this._renderButton({ disabled: items.length === 0 }),
            options && options.length > 0 ?
                <Menu key={1}
                    {...this.menuAnchor()}
                    open={menuState}
                    onClose={this.handleClose}
                    onClick={(e) => { e.stopPropagation(); }}  //阻止默认事件，主要是为了在datagrid中，阻止点击按钮后，行也被选择了

                    MenuListProps={{
                        style: {
                            width: width || "auto",
                        },
                    }}>
                    {items}
                </Menu> : null]
        )
    }

}

More.defaultProps = {
    className: '',
    iconClassName: 'm-text-muted'
}

//右键菜单，不需要按钮
export class ContextMenu extends More {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            mouseX: null,
            mouseY: null
        }
    }

    open(event) {
        let { disabled } = this.state;
        if (disabled) return;

        this.setState({
            mouseX: event.clientX - 2,
            mouseY: event.clientY - 4,
        }, () => {
            this.onOptionSelect(event);
        });
    }

    menuAnchor() {
        const { mouseX, mouseY } = this.state;
        return {
            anchorReference: "anchorPosition",
            anchorPosition:
                mouseY !== null && mouseX !== null
                    ? { top: mouseY, left: mouseX }
                    : undefined
        }
    }

    _renderButton() {
        return null;
    }
}

class MoreItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // auth: "loading"
        }
    }

    componentDidMount() {//auth改动
        let my = this;
        let { data } = this.props;

        let { disabled, disabledTip } = data;
        if (disabled === true) {
            my.setState({
                disabled,
                disabledTip,
            });
            return;
        }

        // auth(data, {
        //     before: () => {
        //         my.setState({
        //             auth: "loading"
        //         });
        //     }, success: () => {
        //         my.setState({
        //             auth: "success"
        //         });
        //     }, error: () => {
        //         my.setState({
        //             auth: "error"
        //         });
        //     }
        // });

    }

    tooltip(content) {
        let { tip, tipPlacement } = this.props;
        let { disabled, disabledTip } = this.state;
        return Tooltip({
            description: disabled ? disabledTip : tip,
            placement: tipPlacement,
            content: <div>{content}</div>
        })
    }

    renderLink(lable) {
        let { data, onClick } = this.props;
        let href = Util.type(data.href) === "function" ? data.href() : data.href;
        let { disabled } = this.state;
        return (
            <MenuItem disabled={disabled} className="c-px-4d5" onClick={(e) => { onClick(e); }}>
                <a className="c-a" href={href} target="_blank">
                    {
                        data.icon ?
                            createIcon(data.icon, `zmdi mr-2 align-middle c-menu-icon`)
                            : null
                    }
                    {lable}</a>
            </MenuItem>
        )
    }

    renderMain(lable) {
        let { data, onClick } = this.props;
        let { disabled } = this.state;
        return (
            <MenuItem disabled={disabled} className="c-px-4d5" onClick={(e) => { onClick(e); }}>
                {
                    data.icon ?
                        <ListItemIcon style={{ minWidth: 'auto' }}>
                            {createIcon(data.icon, `zmdi mr-2 align-middle c-menu-icon`)}
                        </ListItemIcon >
                        : null
                }
                {lable}
            </MenuItem >
        )
    }

    // renderAuth(){
    //     let {auth} = this.state;
    //     if(auth==="loading") return (
    //         <MenuItem>
    //             <ListItemIcon style={{ minWidth: 'auto' }}>
    //                 {createIcon(VerifiedUserOutlinedIcon, `zmdi mr-2 align-middle c-menu-icon`)}
    //             </ListItemIcon>
    //             正在效验权限
    //         </MenuItem>
    //     );
    //     return null; //success和none状态下，都不用通过auth显示
    // }

    // unauthorized(){
    //     return this.state.auth==="error";
    // }


    render() {
        // if(this.unauthorized()) return null;
        // let renderAuth = this.renderAuth();
        // if(renderAuth) return renderAuth;
        let { data } = this.props;
        let lable = data.label || data.text;
        let isLink = data.href;
        return this.tooltip(isLink ? this.renderLink(lable) : this.renderMain(lable));
    }
}

MoreItem.defaultProps = {

}

export let MoreVert = (props) => {
    return <More type="vert" {...props} />
}


export let MoreHoriz = (props) => {
    return <More type="horiz" {...props} />
}

export class ButtonMore extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            anchorEl: undefined,
            menuState: false
        }
    }

    onOptionSelect = event => {
        this.setState({ menuState: true, anchorEl: event.currentTarget });
    };
    handleClose = () => {
        this.setState({ menuState: false });
    };

    render() {
        let { options } = this.props;
        const { menuState, anchorEl } = this.state;
        var p = { ...this.props };
        delete p.options;
        return (
            [<Button key={0} {...p} onClick={this.onOptionSelect} />,
            options && options.length > 0 ?
                <Menu key={1}
                    anchorEl={anchorEl}
                    open={menuState}
                    onClose={this.handleClose}

                    MenuListProps={{
                        style: {
                            width: 100,
                        },
                    }}>
                    {options.map((option, index) =>
                        <MenuItem key={index} onClick={() => { if (option.onClick) option.onClick(); this.handleClose(); }}>
                            {option.label || option.text}
                        </MenuItem>
                    )}
                </Menu> : null]
        )
    }
}

export class OutlinedButtonMore extends More {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state
        }
    }

    renderChildren() {
        let { children, selectMode, options } = this.props;
        if (!selectMode) return children;
        let current = this.getCurrent();
        if (!current) {
            current = options && options.length > 0 ? options[0] : null;
        }
        if (current) return current.label || current.text;
    }

    renderButton({ disabled }) {
        let { button, selectMode, style, className, iconClassName, size } = this.props;
        if (selectMode) button = button || { rightIcon: ExpandMoreIcon, color: "default" };
        return (
            <OutlinedButton key={"outlinedButton"} onClick={this.onOptionSelect} size={size} style={style} disabled={disabled} className={className} iconClassName={iconClassName} {...button}>
                {this.renderChildren()}
            </OutlinedButton>
        );
    }
}

OutlinedButtonMore.defaultProps = {
    disabledTip: "无此权限",
    selectMode: false,
    //className: 'bg-white',
    size: "sm",
    // color: "default",
    // iconColor: "disabled",
    // iconSize: "small",
    // iconClassName: ''
}

export class Tabs extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            value: props.value || 0
        }
        this.init();
    }

    componentDidMount() {
        let { value } = this.props;
        if (!Util.empty(value)) {
            this.handleChange(value);
        }
    }

    init() {
        let { items } = this.props;
        items.forEach((t, i) => { //自动给予value，我们要求外界传来的数据，要么全部没有value，要么都设置了value
            if (Util.empty(t.value))
                t.value = i;
        });
    }

    badge({ t, active }) {
        if (Util.empty(t.count)) return null;

        let count = t.count > 99 ? "99+" : t.count;
        let { items, textColor, badgeColor, textActiveColor, badgeActiveColor } = this.props;

        if (runtime.mobile) {
            return <span className="c-text-s0 ml-1">{`(${count})`}</span>
        }

        let tc = active ? textActiveColor : textColor;
        let bc = active ? badgeActiveColor : badgeColor;
        return <Badge textColor={tc} color={bc} pill={true} size="sm" className="mb-0 ml-1">{count}</Badge>;
    }

    handleChange(value) {
        this.setState({ value })
        let { onChange } = this.props;
        if (onChange) onChange(value);

    }

    render() {
        let { items, textColor, badgeColor, textActiveColor, badgeActiveColor } = this.props;
        let { value } = this.state;

        return (
            <div className={`c-button-tabs d-flex flex-row align-items-center`}>
                {
                    items.map((t, i) => {
                        let active = t.value == value;
                        return <div key={i} className={`c-pointer d-flex flex-column justify-content-center align-items-center ${i > 0 ? 'ml-2' : ''}`} onClick={() => { this.handleChange(t.value); }}>
                            <div className={`d-flex px-1 px-sm-2 c-text-s2 c-text-sm-s3 flex-row justify-content-center align-items-center c-text-${active ? textActiveColor : textColor}`}>
                                {t.label}
                                {this.badge({ t, active })}
                            </div>
                            <div className={`${active ? `c-bg-${textActiveColor}` : ''} w-100`} style={{ height: 3 }}></div>
                        </div>
                    })
                }
            </div>
        );
    }
}

Tabs.defaultProps = {
    textColor: "dark",
    badgeColor: "light",
    textActiveColor: "pink",
    badgeActiveColor: "light",
}

const sheetActionRowClassName = "d-flex flex-row justify-content-center align-items-center py-2 c-mh3 c-md-mh4";
const sheetActionTextClassName = "c-text-s1 c-text-md-s2 mb-0";

export class SheetAction extends React.Component {

    open(p) {
        this.refs.sheet.open(p);
    };

    close(p) {
        this.refs.sheet.close(p);
    };

    renderItem(option, index, options) {
        if (option.href) {
            return <SheetAction.LinkItem key={index} label={option.text || option.label} color={option.color} href={option.href} onClick={(e) => { this.close(); }} />;
        } else {
            return <SheetAction.Item key={index} last={index == options.length - 1} label={option.text || option.label} color={option.color} onClick={(e) => { if (option.onClick) option.onClick(e); this.close(); }} />;
        }
    }

    render() {
        let { options, title } = this.props;
        var p = { ...this.props };
        delete p.children; delete p.title; delete p.options;
        return (
            <Sheet ref="sheet" {...p}>
                <div className="bg-white">
                    {title ?
                        [<div key={0} className={`${sheetActionRowClassName}`}>
                            <p className={`${sheetActionTextClassName} c-text-grey`}>{title}</p>
                        </div>,
                        <Divider key={1} />]
                        : null}
                    {options.map((option, index) =>
                        this.renderItem(option, index, options)
                    )}
                    <div className="w-00 c-mh1 bg-light"></div>
                    <Divider />
                    <div className={`${sheetActionRowClassName} mx-2`} onClick={() => { this.close(); }}>
                        <p className={`${sheetActionTextClassName} c-text-grey`}>取消</p>
                    </div>
                </div>
            </Sheet>
        )
    }
}

SheetAction.defaultProps = {
    options: []
}

//SheetActionItem

SheetAction.Item = (props) => {
    let { label, last, color, onClick } = props;
    color = color || 'dark';
    return [<div key={0} className={`${sheetActionRowClassName}`} onClick={onClick}>
        <p className={`${sheetActionTextClassName} c-text-${color}`}>{label}</p>
    </div>, <Divider key={1} />]
}

//嵌入a标签的Item
SheetAction.LinkItem = (props) => {
    let { label, color, href, onClick } = props;
    color = color || 'dark';
    return [<div key={0} className={`${sheetActionRowClassName}`} onClick={onClick}>
        <a className={`${sheetActionTextClassName} c-text-${color} c-a`} href={href} target="_blank">{label}</a>
    </div>, <Divider key={1} />]
}

export class ActionGroup extends React.Component {

    constructor(props) {
        super(props);
    }

    main() {
        let { children, title, moreClassName } = this.props;
        if (Util.type(children) != "array") children = [children];
        let options = children.map((c) => {
            let { onClick, label, color, icon, href, permission, disabled, disabledTip } = c.props;
            return { icon: icon, color, label, href, permission, disabled, disabledTip, onClick }
        }).filter(function (item) {
            return item != null;
        });
        return <MoreVert title={title} className={moreClassName} options={options} />
    }


    // pc() {
    //     let { children } = this.props;
    //     return <div className="d-flex flex-row justify-content-center align-items-center">
    //         {children}
    //     </div>
    // }


    render() {
        let { className } = this.props;
        return (
            <div className={className}>
                {this.main()}
            </div>
        )
    }

}

ActionGroup.defaultProps = {
    className: '',
    MoreclassName: 'c-text-grey c-icon-s2 c-icon-md-s3'
}